import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import { useHistory } from 'react-router-dom';
import { ROUTE_PATH } from '../../routes/paths';
import React, { useState } from 'react';

type props = {
  listenerName?: string | null;
  listenerId?: number;
};

const HeadBack: React.FunctionComponent<props> = ({ listenerName, listenerId }) => {
  const history = useHistory();
  const [isNavigating, setIsNavigating] = useState(false);

  const handleClick = () => {
    setIsNavigating(true);
    history.push(ROUTE_PATH.PEERS);
  };

  return (
    <div className="flex w-full items-center">
      <div
        className={`mr-4 flex cursor-pointer justify-end rounded-full bg-white transition-opacity ${isNavigating ? 'opacity-50' : 'hover:opacity-80'}`}
        role="button"
        onClick={handleClick}
      >
        <img className="pointer-events-none h-8 w-8" src={RightArrow} alt="left Arrow"></img>
      </div>
      <p>{listenerName || ''}</p>
      {listenerId && (
        <button
          className="ml-4 rounded bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700"
          onClick={() =>
            window.open(`${process.env.REACT_APP_MWA_LINK}/peer-details?listenerId=${listenerId}`, '_blank')
          }
        >
          View Peer in MWA
        </button>
      )}
      {isNavigating && <span className="ml-3 text-sm text-gray-600">Loading...</span>}
    </div>
  );
};

export default HeadBack;
